import { OpenThermFaultFlag, OpenThermStatusFlag } from 'openTherm';
export function otHasError(boiler_type, ot, ba_status) {
    if (boiler_type == 'dedietrich-naneo-s') {
        const err_in_s = (ot?.s ?? []).includes(OpenThermStatusFlag.f);
        const err_in_ff = (ot?.ff?.f ?? []).includes(OpenThermFaultFlag.sr);
        const err_in_rbp = ot?.rbp != null &&
            !(ot.rbp[0] == 255 && ot.rbp[1] == 255) &&
            !(ot.rbp[0] == 0 && ot.rbp[1] == 0);
        return err_in_s || err_in_ff || err_in_rbp;
    }
    return ((ot?.s ?? []).includes(OpenThermStatusFlag.f) ||
        !!ba_status?.event_boiler_fail ||
        !!ba_status?.boiler_fail);
}
